import React, {useState, useEffect} from "react"
import axios from "../../axiosConfig"
import {
    Row,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Col,
    Container,
    Collapse,
    Alert
} from "reactstrap"
import Navbar from "components/Navbar/Navbar.js"
import Footer from "components/Footer/Footer.js"

const Admin = () => {

    useEffect(() => {
        document
            .body
            .classList
            .add("index-page")
        document
            .body
            .classList
            .add("sidebar-collapse")
        document
            .documentElement
            .classList
            .remove("nav-open")
        return function cleanup() {
            document
                .body
                .classList
                .remove("index-page")
            document
                .body
                .classList
                .remove("sidebar-collapse")
        }
    })

    const styles = {
        border: {
            border: "1px solid #E3E3E3",
            borderRadius: "20px"
        }
    }

    const [disabled,
        setDisabled] = useState(true)
    const [isOpen,
        setIsOpen] = useState({})
    const [project,
        setProject] = useState({members: {}})
    const [noOfMembers,
        setNoOfMembers] = useState(0)
    const [alert,
        setAlert] = useState({enabled: false, variant: "", message: "", icon: ""})
    const [warning,
        setWarning] = useState({enabled: true, messages: {}})

        useEffect(() => {
            const fetchData = async() => {
                const result = await axios('warning.json',)
                setWarning({messages: result.data})
            }
            fetchData()
        }, [])

    const ObjectLength = object => {
        let length = 0
        for (let key in object) {
            if (object.hasOwnProperty(key)) {
                ++length
            }
        }
        return length
    }

    const toggle = value => {
        setIsOpen({
            // uncomment the below line to open all ...isOpen,
            [value]: isOpen[value]
                ? !isOpen[value]
                : true
        })
    }

    const setNumerToBeMapped = event => {
        let length = parseInt(event.target.value, 10)
        if (!Number.isInteger(length) || length < 0) {
            setAlert({
                enabled: true,
                message: "Invalid value " + length,
                variant: "danger",
                icon: "now-ui-icons objects_support-17"
            })
            length = 0
            window.scrollTo(0, 0)
        } else {
            setNoOfMembers(length)
        }
    }

    const updateProject = (event, key) => {
        let value = event.target.value
        if (key === "description") 
            JSON.stringify(value)
        setProject({
            ...project,
            [key]: value
        })
    }

    const updateMemebers = (event, member, key) => {
        const data = {
            ...project
        }
        if (data["members"] === undefined) 
            data["members"] = {}
        if (data["members"][member] === undefined) 
            data["members"][member] = {}
        data["members"][member][key] = event.target.value
        setProject(data)
    }

    const fetchProjctData = async id => {
        let result = await axios(`projects/${id}.json`)
        if (result.data) {
            setProject(result.data)
            if (result.data.members) {
                let noMembers = ObjectLength(result.data.members)
                setNoOfMembers(noMembers)
            }
        }
        setDisabled(false)
    }

    const saveProjectToDB = async event => {
        event.preventDefault()
        if (project.pid) {
            await axios.put("projects/" + project.pid + ".json", project)
            setAlert({
                enabled: true,
                message: "Updated project with id: " + project.pid,
                icon: "now-ui-icons ui-2_like"
            })
        } else {
            setAlert({enabled: true, message: "Please provide a valid Project ID", variant: "danger", icon: "now-ui-icons objects_support-17"})
        }
        window.scrollTo(0, 0)
    }

    const validateId = async(event, key) => {
        let event_holder = {
            target: {
                value: event.target.value
            }
        }
        let key_holder = key
        let projectId = event.target.value
        const result = await axios("metadata.json")
        if (result["data"]["ids"].includes(projectId)) {
            updateProject(event_holder, key_holder)
            await fetchProjctData(projectId)
        } else {
            setAlert({enabled: true, message: "Please provide a valid Project ID", variant: "danger", icon: "now-ui-icons objects_support-17"})
            window.scrollTo(0, 0)
        }
    }

    const projectData = (
        <div>
            <Row form>
                <Col md={4}>
                    <FormGroup>
                        <Label for="pid">Project ID</Label>
                        <Input
                            onBlur={event => validateId(event, "pid")}
                            type="text"
                            name="pid"
                            id="pid"
                            placeholder="Project ID"/>
                    </FormGroup>
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <Label for="n">Project Name</Label>
                        <Input
                            onChange={event => updateProject(event, "name")}
                            type="text"
                            name="name"
                            id="name"
                            placeholder="Project name"
                            value={project.name
                            ? project.name
                            : ""}
                            disabled={disabled}/>
                    </FormGroup>
                </Col>
                <Col md={4}>
                    <FormGroup>
                        <Label for="noOfMemebrs">Number of Members</Label>
                        <Input
                            onChange={event => setNumerToBeMapped(event)}
                            type="number"
                            name="noOfMemebrs"
                            id="noOfMemebrs"
                            placeholder="1-8"
                            disabled={disabled}/>
                    </FormGroup>
                </Col>
            </Row>
            <FormGroup>
                <Label for="shortDescription">Short Description</Label>
                <Input
                    style={styles.border}
                    onChange={event => updateProject(event, "shortDescription")}
                    type="textarea"
                    name="shortDescription"
                    id="shortDescription"
                    placeholder="Add short description here... it may have mark up (pics, titles, etc) ###Hello"
                    value={project.shortDescription
                    ? project.shortDescription
                    : ""}
                    disabled={disabled}/>
            </FormGroup>
            <FormGroup>
                <Label for="description">Description</Label>
                <Input
                    style={styles.border}
                    onChange={event => updateProject(event, "description")}
                    type="textarea"
                    name="description"
                    id="description"
                    placeholder="Add description here"
                    value={project.description
                    ? project.description
                    : ""}
                    disabled={disabled}/>
            </FormGroup>
            <FormGroup>
                <Label for="picture">Picture</Label>
                <Input
                    onChange={event => updateProject(event, "picture")}
                    type="text"
                    name="picture"
                    id="picture"
                    placeholder="Add picture URL in here"
                    value={project.picture
                    ? project.picture
                    : ""}
                    disabled={disabled}/>
            </FormGroup>
            <FormGroup>
                <Label for="youtube">Video</Label>
                <Input
                    onChange={event => updateProject(event, "youtube")}
                    type="text"
                    name="youtube"
                    id="youtube"
                    placeholder="Add Video URL in here... https://www.youtube.com/embed/m1K33ZDb35t"
                    value={project.youtube
                    ? project.youtube
                    : ""}
                    disabled={disabled}/>
            </FormGroup>
        </div>
    )

    let mapMembers = [...Array(noOfMembers)].map((e, index) => (
        <div key={"member" + (index + 1)}>
            <Row>
                <Col md={12}></Col>
            </Row>
            <Button
                color="primary"
                onClick={() => toggle("m" + index)}
                style={{
                marginBottom: "1rem"
            }}>
                {project.members[`m${index + 1}`]
                    ? project.members[`m${index + 1}`].firstName
                    : "Member " + (index + 1)}
            </Button>
            <Collapse isOpen={isOpen["m" + index]}>
                <Row form>
                    <Col md={6}>
                        <FormGroup>
                            <Label for="firstName">First name</Label>
                            <Input
                                onChange={event => updateMemebers(event, "m" + (index + 1), "firstName")}
                                type="text"
                                name="firstName"
                                placeholder="Your name..."
                                id="firstName"
                                value={project.members[`m${index + 1}`]
                                ? project.members[`m${index + 1}`].firstName
                                : ""}/>
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Label for="lastName">Last Name</Label>
                            <Input
                                onChange={event => updateMemebers(event, "m" + (index + 1), "lastName")}
                                type="text"
                                name="lastName"
                                placeholder="Your family name..."
                                id="lastName"
                                value={project.members[`m${index + 1}`]
                                ? project.members[`m${index + 1}`].lastName
                                : ""}/>
                        </FormGroup>
                    </Col>
                </Row>
                <FormGroup>
                    <Label for="description">Description</Label>
                    <Input
                        style={styles.border}
                        onChange={event => updateMemebers(event, "m" + (index + 1), "description")}
                        type="textarea"
                        name="description"
                        id="description"
                        placeholder="Add description here... you can have a longer description now."
                        value={project.members[`m${index + 1}`]
                        ? project.members[`m${index + 1}`].description
                        : ""}/>
                </FormGroup>
                <FormGroup>
                    <Label for="avatar">Avatar</Label>
                    <Input
                        onChange={event => updateMemebers(event, "m" + (index + 1), "avatar")}
                        type="text"
                        name="avatar"
                        id="avatar"
                        placeholder="Add avatar URL in here"
                        value={project.members[`m${index + 1}`]
                        ? project.members[`m${index + 1}`].avatar
                        : ""}/>
                </FormGroup>
                <FormGroup>
                    <Label for="github">Github</Label>
                    <Input
                        onChange={event => updateMemebers(event, "m" + (index + 1), "github")}
                        type="text"
                        name="github"
                        id="github"
                        placeholder="Add github URL in here"
                        value={project.members[`m${index + 1}`]
                        ? project.members[`m${index + 1}`].github
                        : ""}/>
                </FormGroup>
                <FormGroup>
                    <Label for="linkedin">LinkedIn</Label>
                    <Input
                        onChange={event => updateMemebers(event, "m" + (index + 1), "linkedin")}
                        type="text"
                        name="linkedin"
                        id="linkedin"
                        placeholder="Add linkedin URL in here"
                        value={project.members[`m${index + 1}`]
                        ? project.members[`m${index + 1}`].linkedin
                        : ""}/>
                </FormGroup>
            </Collapse>
        </div>
    ))

    return (
        <div>
            <Navbar/>

            <div style={{
                padding: "80px 0 0 0"
            }}>
                {Object
                            .entries(warning.messages)
                            .map(([key, item]) => {
                                return(<Alert key={key} color="warning" isOpen={warning.enabled}>
                    <Container>
                        <div className="alert-icon">
                            <i className="now-ui-icons ui-1_bell-53"></i>
                        </div>
                        <strong>Warning!</strong> {item}
                        <button type="button" className="close" onClick={() => setWarning({enabled: false})}>
                            <span aria-hidden="true">
                                <i className="now-ui-icons ui-1_simple-remove"></i>
                            </span>
                        </button>
                    </Container>
                </Alert>)
                            })}

                {/* <Alert color="warning" isOpen={warning.enabled}>
                    <Container>
                        <div className="alert-icon">
                            <i className="now-ui-icons ui-1_bell-53"></i>
                        </div>
                        <strong>Warning!</strong>
                        YouTube link should not include the iframe code. The URL should look like:
                        https://www.youtube.com/embed/abc123
                        <button type="button" className="close" onClick={() => setWarning({enabled: false})}>
                            <span aria-hidden="true">
                                <i className="now-ui-icons ui-1_simple-remove"></i>
                            </span>
                        </button>
                    </Container>
                </Alert> */}
            </div>

            <div>
                <Alert color={alert.variant} isOpen={alert.enabled}>
                    <Container>
                        <div className="alert-icon">
                            <i className={alert.icon}></i>
                        </div>
                        <strong>{alert.message}</strong>
                        <button type="button" className="close" onClick={() => setAlert({enabled: false})}>
                            <span aria-hidden="true">
                                <i className="now-ui-icons ui-1_simple-remove"></i>
                            </span>
                        </button>
                    </Container>
                </Alert>
            </div>

            <div className="section content-center">
                <Container>
                    <Form>
                        {projectData}
                        {mapMembers}
                        <Row>
                            <Col md={12}></Col>
                        </Row>
                        <Button
                            color="info"
                            disabled={disabled}
                            onClick={event => saveProjectToDB(event)}>
                            Submit
                        </Button>
                    </Form>
                </Container>
            </div>
            <Footer/>
        </div>
    )
}

export default Admin
